import { cn } from "@gigpro/ui/tailwind/cn";
import { Link } from "@tanstack/react-router";
import React from "react";
import type { NavItem } from "../types";
import { useNavLinkProps, useDoesPathMatch } from "../utils";

type SidebarItemProps = {
  item: NavItem;
  onClick?: () => void;
};

const iconWrapperClassNames = cn("[&>*:first-child]:mr-2 [&>*:first-child]:size-4");
const commonItemClassNames = cn("flex flex-row items-center p-2 px-3.5 text-normal whitespace-nowrap");

export const SidebarItem: React.FC<SidebarItemProps> = ({ item, onClick }) => {
  const matchesPath = useDoesPathMatch(item.type === "link" ? item : { path: "", external: true });
  const navLinkProps = useNavLinkProps();

  if (item.type === "link") {
    const { title, icon, external } = item;
    return (
      <Link
        key={title}
        {...navLinkProps(item)}
        target={external ? "_blank" : "_self"}
        onClick={onClick}
        className={cn(commonItemClassNames, "transition-colors", matchesPath && "bg-brand text-white")}
      >
        <span className={iconWrapperClassNames}>{icon}</span>
        {title}
        {item.isBeta ? (
          <span style={{ marginLeft: "9px" }} className="rounded-xl bg-tags-green px-2 text-small text-black">
            <b>Beta</b>
          </span>
        ) : null}
      </Link>
    );
  }
  if (item.type === "button") {
    return (
      <button
        key={item.title}
        type="button"
        onClick={() => {
          item.onClick();
          onClick?.();
        }}
        className={cn(commonItemClassNames, iconWrapperClassNames)}
      >
        {item.icon}
        {item.title}
      </button>
    );
  }
  if (item.type === "subheader") {
    return (
      <React.Fragment key={item.title}>
        <hr className="mt-1 w-full bg-gray/50 text-gray/50" />
        <p className="w-full p-2 text-small font-semibold opacity-70">{item.title}</p>
      </React.Fragment>
    );
  }
  if (item.type === "divider") {
    return <hr className="my-2 w-full bg-gray/50 text-gray/50" />;
  }
};
